import { render, staticRenderFns } from "./QueryPolicy.vue?vue&type=template&id=8027b114&"
import script from "./QueryPolicy.vue?vue&type=script&lang=js&"
export * from "./QueryPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports